<template>
  <div class="main">
    <a-card
      title="推送信息"
      :bordered="false"
      style="width: 800px; margin: 20px auto; padding: 10px"
    >
      <p>
        <a-input placeholder="文章ID" v-model="id" />
      </p>
      <p>
        <a-input
          placeholder="标题，20字符以内"
          v-model="title"
          :maxLength="titleLenght"
        />
      </p>
      <p>
        <a-textarea
          placeholder="文章摘要，50字符以内"
          allow-clear
          :maxLength="bodyLenght"
          v-model="body"
        />
      </p>
      <p style="float: right">
        <a-button @click="showConfirm"> 推送 </a-button>
      </p>
    </a-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      id: '',
      title: '',
      body: '',
      titleLenght: 20,
      bodyLenght: 50,
    };
  },
  methods: {
    showConfirm() {
      let _this = this;
      this.$confirm({
        title: '推送确认',
        content: '确认以上推送信息吗？',
        onOk() {
          _this.doPush();
        },
        onCancel() {},
      });
    },
    doPush() {
      if (this.id.length < 2 || this.title.length < 2 || this.body.length < 2) {
        this.$message.error('ID，标题，摘要均不能为空');
      } else {
        let param = { id: this.id, title: this.title, body: this.body };
        this.$http
          .post('https://cn3xapi.ycrmt.cn/fusionMedia/appPush', param)
          .then((res) => {
            if (res.status == 200 && res.data.errno == 0) {
              this.$message.success('推送成功');
            }
          });
      }
    },
  },
};
</script>

<style>
</style>